<div class="tkebulk">
  <div class="container-fluid">
    <br />
    <br />

    <div class="row">
      <div class="col-sm-6">
        Download Template
      </div>
      <div class="col-sm-6">
        <a style="color: #ff8708; cursor:pointer"  (click)="getexcelfile()">add_bulk_user_template</a>
      </div>
    </div>

    <br />
    <br />

    <div class="row">
      <div class="col-sm-12 m-15">
        <div ng2FileDrop
          [ngClass]="{'another-file-over-class': hasBaseDropZoneOver}"
          (fileOver)="fileOverBase($event)"
          [uploader]="uploader"
          (click)="fileInput.click()"
          (onFileDrop)="onFileChange($event)"
          class="well my-drop-zone mt-2">
          Drag and drop files here or click to select*
        </div>
        <!-- @if () block removed - was causing NG5002 error -->
        <span class="hidden-file">
          <input type="file" #fileInput ng2FileSelect [multiple]="false"  (onFileSelected)="onFileChange($event)"  onclick="this.value=null;"  [uploader]="uploader"  accept=".xlsx" />
        </span>

      </div>
    </div>

    <br />

    <div class="col-sm-12">
      @if (isfilePreloadError) {
        <p style="color:red">{{preLoadErrorMsg}}</p>
      }
      @if (!isfilePreloadError) {
        <table  class="table">
          <tbody>
            <tr>
              <th>Name</th>
              <th>Size</th>
            </tr>
            <tr>
              <td>
                {{ fileName }}
              </td>
              <td>
                {{ fileSize/1024/1024 | number:'.2' }} MB
              </td>
            </tr>
          </tbody>
        </table>
      }
    </div>

    @if (!isfilePreloadError) {
      <div  class="row ">
        <div class="col-sm-12">
          @if (showAllSuccessfullyValidated) {
            <div style="display: flex; flex-direction: row; justify-content: center; background-color: darkgreen">
              All data was successfully validated
            </div>
          }
          <div style="display:flex; flex-direction: row; justify-content: center">
            @if (isLoading) {
              <mat-progress-bar class="wikiPrgressBar" mode="indeterminate" style=" width: 54%;"></mat-progress-bar>
            }
          </div>
          <div [hidden]="hideBulkTable">
            <!-- Your content here -->
            <div style="background-color: #ff8708; display: flex; flex-direction: row; justify-content: center">
              WARNINGS
            </div>
            <div class="bulk_scrollable-container">
              <table border="1" class="table">
                <tbody>
                  <tr>
                    <th>Email</th>
                    <th>Validation</th>
                    <th>First Name</th>
                    <th>Last Name</th>
                    <th>Display Name</th>
                    <th>Primary Tenant</th>
                    <th>Company Name</th>
                    @if (allAvlblEmtRoles['IsVisible']) {
                      <th>EMT Role</th>
                    }
                    @if (allAvlblBranches['IsVisible']) {
                      <th>Branch</th>
                    }
                    @if (allAvlblMaxRoles['IsVisible']) {
                      <th>MAX_Roles</th>
                    }
                  </tr>
                  @for (row of data; track row) {
                    <tr>
                      @for (val of row; track val; let i = $index) {
                        <td [style.color]="getColor(val, i)">
                          {{val}}
                        </td>
                      }
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    }

    <br />



    <div class="row">
      <div class="panel-body">
        <button (click)="backButtonHandler($event)" mat-raised-button class="btn button-fix button-color-fix-red ">
          <mat-icon class=" icon-color-fix ">arrow_back_ios</mat-icon>
          Back
        </button>
        <button mat-raised-button (click)="bulkUsers()" type="submit" class="btn button-fix button-color-fix-orange pull-right" [disabled]="isButtonDisabled || isfilePreloadError">
          Create
          <mat-icon class=" icon-color-fix ">person</mat-icon>
        </button>


      </div>
    </div>


  </div>


</div>



